module.exports = __webpack_public_path__ + "img/step5-c.0139d11a.png";